import { Box, Stack, Text, Tiles, Heading } from 'braid-design-system';
import React from 'react';

import { useLocalized } from 'src/shared/hooks';

import { sellingPointWidth } from '../style/style.css';

const SellingPoints = () => {
  const data = [
    {
      title: 'No. 1 employment site',
      desc: useLocalized({
        AU: "Australia's most visited employment site with over 2.5 times the visits of our nearest competitor",
        NZ: 'Almost twice as many candidates used SEEK in their last job search, than any other online site',
      }),
    },
    {
      title: useLocalized({
        AU: '1 in 3',
        NZ: '1 in 4',
      }),
      desc: useLocalized({
        AU: 'Australians found their job on SEEK in the last 12 months',
        NZ: "New Zealander's found their job on SEEK  In the last 12 months",
      }),
    },
    {
      title: '1,900 hirers',
      desc: 'use branding on their SEEK job ads each month to engage and find the right candidates',
    },
  ];

  return (
    <Tiles space={['xlarge']} columns={[1, 3]}>
      {data.map((item, i) => (
        <Box key={i}>
          <Stack space="gutter" align="center">
            <Heading level="3" align="center">
              {item.title}
            </Heading>
            <Box key={i} className={sellingPointWidth}>
              <Text align="center" tone="secondary">
                {item.desc}
              </Text>
            </Box>
          </Stack>
        </Box>
      ))}
    </Tiles>
  );
};

export default SellingPoints;
